var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.classNames,style:(_vm.containerStyle),attrs:{"role":"presentation","title":"Подождите..."}},[_c('span',{staticClass:"base-spinner__rotator",style:(_vm.spinnerStyle)})])}
var staticRenderFns = []

export { render, staticRenderFns }